import { useState, useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { toast, Toaster } from "react-hot-toast";
import { Input } from "reactstrap";
import { map } from "lodash";

import { useUsersActions } from "../../../../services/actions/users.actions";
import { loginAtom, userAtom } from "../../../../services/atoms/auth.atoms";
import { crudUserAtom } from "../../../../services/atoms/users.atoms";
import { ButtonLoading } from "../../../../components/buttons/button-loading";
import { newValidatePhone, validateEmail, validatePhone } from "../../../../helpers/functions";

// TODO won't work, needs to be update to use new backend endpoints
const PersonalInfoForm = () => {
  const [userData, setUserData] = useRecoilState(userAtom);
  const { updateUserAttributes, resetUserCrud, userList } = useUsersActions();

  const [user, setUser] = useState({ ...userData.data, phone_number: userData.data.phone_number });
  const [login, setLogin] = useRecoilState(loginAtom);

  const userResolver = useRecoilValue(crudUserAtom);

  useEffect(() => {
    setUser({ ...userData.data, phone_number: userData.data.phone_number });
  }, [userData.data])

  useEffect(() => {
    userResolver.error
     && toast.error(userResolver.message);
    return () => {
      toast.dismiss();
      resetUserCrud();
    }

    // eslint-disable-next-line
  }, [userResolver.error, userResolver.message]);

  const handleChange = (key, value) => setUser((prevValues) => ({ ...prevValues, [key]: value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    let keys = ['name', 'family_name', 'phone_number'];
    let attributes = map(keys, (e) => ({ Name: e, Value: e === 'phone_number' ? `${user[e]}` : user[e] }));
    setLogin((prevValues) => ({ ...prevValues, updating: true }));
    updateUserAttributes(user.email, attributes, () => {
      toast.success('Datos actualizados exitosamente');
      setUserData((prevValues) => ({ ...prevValues, ...user }));
      userList()
      setLogin((prevValues) => ({ ...prevValues, updating: false }));
    });
  }

  return (
    <form className="gm-form" onSubmit={handleSubmit}>
    <Toaster />
      <div className='gm-form-container'>
        <div className='gm-form-section'>
          <div className='gm-form-section-title'>Perfil</div>
          <div className='gm-form-group'>
            <div className='gm-input-group'>
              <label htmlFor='name'>Nombres</label>
              <input type="text"
                id='name'
                name="name"
                value={user?.name || ''}
                onChange={(e) => handleChange('name', e.target.value)}
              />
            </div>
            <div className='gm-input-group'>
              <label htmlFor='family_name'>Apellidos</label>
              <input
                type="text"
                id='family_name'
                name="family_name"
                value={user.family_name || ''}
                onChange={(e) => handleChange('family_name', e.target.value)}
              />
            </div>
          </div>
          <div className='gm-form-group'>
            <div className='gm-input-group'>
              <label htmlFor='email'>Correo</label>
              <Input
                type="email"
                id='email'
                name="email"
                value={user?.email || ''}
                onChange={(e) => handleChange('email', e.target.value)}
                invalid={validateEmail(user.email)}
                disabled
              />
            </div>
            <div className='gm-input-group'>
              <label htmlFor='phone_number'>Teléfono</label>
                  <Input
                  type="text"
                  id='phone_number'
                  name='phone_number'
                  value={user.phone_number}
                  onChange={(e) => handleChange('phone_number', e.target.value)}
                  maxLength={20}
                  invalid={!newValidatePhone(user.phone_number)}
                  placeholder="+56 1234 5678"
                />
            </div>
          </div>
        </div>
      </div>
      <div className='gm-buttons'>
        <ButtonLoading
          className="gm-primary-button"
          type="submit"
          buttonLabel='Actualizar Datos'
          disabled={login.updating || !newValidatePhone(user.phone_number) || validateEmail(user.email)}
          loading={login.updating}
        />
      </div>
    </form>
  );
}

export default PersonalInfoForm;